import { Injectable } from '@angular/core';
import { type Action } from '@ngrx/store';
import { type MonoTypeOperatorFunction } from 'rxjs';

/** No debugger attached: workflow steps run straight through. */
class NoWorkflowStepDebugger implements WorkflowStepDebugger {
  interceptStep(): MonoTypeOperatorFunction<Action> {
    return (steps) => steps;
  }
}

/**
 * The hook the workflow debugger attaches to workflow execution.
 *
 * Every node the engine is about to apply passes through {@link interceptStep}. With a debug session
 * in progress the editor turns that step into a debugger step — pausing on a breakpoint, recording it
 * in the execution history — and otherwise lets it through untouched.
 *
 * The engine knows a debugger may be attached; it does not know what one is. The debugger, its state
 * and its stepping rules live in `dashboard/editor/data-access`, which binds this hook.
 */
@Injectable({ providedIn: 'root', useFactory: () => new NoWorkflowStepDebugger() })
export abstract class WorkflowStepDebugger {
  abstract interceptStep(): MonoTypeOperatorFunction<Action>;
}
